<!-- git/truth-first-look/src/components/dashboard/SidebarNav.tsx -->
<nav class="flex flex-col h-full py-4 px-2" aria-label="Main navigation">
  <div class="px-4 mb-4">
    <img [src]="logoSrc" alt="TruthShorts" class="w-9 h-9 object-contain" />
  </div>

  <div class="flex-1 space-y-0.5">
    <button
      *ngFor="let item of items"
      type="button"
      class="group flex items-center gap-4 w-full px-4 py-2.5 rounded-xl text-[15px] transition-all duration-200"
      [ngClass]="activeItem === item.id
        ? 'font-semibold text-foreground bg-secondary'
        : 'font-medium text-muted-foreground hover:text-foreground hover:bg-secondary/60'">
      <span class="relative flex-shrink-0">
        <ng-container [ngSwitch]="item.id">
          <svg *ngSwitchCase="'home'" width="24" height="24" viewBox="0 0 24 24" [attr.fill]="activeItem === 'home' ? 'currentColor' : 'none'" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
            <polyline points="9 22 9 12 15 12 15 22" />
          </svg>
          <svg *ngSwitchCase="'explore'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10" />
            <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
          </svg>
          <svg *ngSwitchCase="'notifications'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
            <path d="M13.73 21a2 2 0 0 1-3.46 0" />
          </svg>
          <svg *ngSwitchCase="'messages'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
            <polyline points="22,6 12,13 2,6" />
          </svg>
          <svg *ngSwitchCase="'bookmarks'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
            <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
          </svg>
          <svg *ngSwitchCase="'profile'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
          <svg *ngSwitchCase="'more'" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <circle cx="12" cy="5" r="1.5" />
            <circle cx="12" cy="12" r="1.5" />
            <circle cx="12" cy="19" r="1.5" />
          </svg>
        </ng-container>
        <span *ngIf="item.badge != null && item.badge > 0" class="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] flex items-center justify-center rounded-full bg-ts-red text-[10px] font-bold text-white px-1">
          {{ item.badge > 99 ? '99+' : item.badge }}
        </span>
      </span>
      <span class="hidden xl:inline">{{ item.label }}</span>
    </button>
  </div>

  <div class="px-2 mt-4">
    <button type="button" class="w-full flex items-center justify-center gap-2 h-12 rounded-xl bg-ts-blue text-white font-semibold text-[15px] transition-all hover:brightness-110 active:scale-[0.98] shadow-sm">
      <svg class="xl:hidden" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 20h9" />
        <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
      </svg>
      <span class="hidden xl:inline">Post</span>
      <svg class="hidden xl:inline" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 20h9" />
        <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
      </svg>
    </button>
  </div>

  <div class="mt-4 px-2">
    <div class="flex items-center gap-3 p-2.5 rounded-xl hover:bg-secondary/60 transition-colors cursor-pointer">
      <div class="w-9 h-9 rounded-full bg-muted flex items-center justify-center overflow-hidden flex-shrink-0">
        <img [src]="userAvatar" alt="" class="w-full h-full object-cover" />
      </div>
      <div class="hidden xl:block min-w-0 flex-1">
        <p class="text-sm font-semibold text-foreground truncate">Truth Shorts</p>
        <p class="text-xs text-muted-foreground truncate">&#64;truthshorts</p>
      </div>
      <svg class="hidden xl:block text-muted-foreground" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <circle cx="12" cy="5" r="1.5" />
        <circle cx="12" cy="12" r="1.5" />
        <circle cx="12" cy="19" r="1.5" />
      </svg>
    </div>
  </div>
</nav>
